import { render, staticRenderFns } from "./MenuIndex.vue?vue&type=template&id=2e7af3fe&scoped=true"
import script from "./MenuIndex.vue?vue&type=script&lang=js"
export * from "./MenuIndex.vue?vue&type=script&lang=js"
import style0 from "./MenuIndex.vue?vue&type=style&index=0&id=2e7af3fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7af3fe",
  null
  
)

export default component.exports